<template>
    <form class="shaded m-5" @submit.prevent.stop="save" novalidate>
        <div class="row">
            <div class="col-sm-9 name-min-height-error">
                <div class="form-group" :class="{ error: $v.form.name.$invalid }">
                    <label class="full">
                        Name <span class="brand">*</span>
                        <input type="text" v-model="form.name">
                    </label>

                    <div v-if="$v.form.name.$invalid" class="messages">
                        <span v-if="!$v.form.name.required">Name is required.</span>
                        <span v-if="!$v.form.name.minLength">Name must have at least 3 characters.</span>
                        <span v-if="!$v.form.name.repeatName">This name already exists. Service name should be unique</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-3" v-if="getShowInvoiceOption">
                <div class="form-group">
                    <label class="full" v-tooltip="billingProductIdTooltip">
                        Billing Product ID
                        <input type="text" v-model="form.code">
                    </label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <label class="full">Service type</label>

                <v-select
                    v-model="componentTypeObject"
                    :options="componentTypesOptions"
                    @input="setComponentType(componentTypeObject.componentType)"
                ></v-select>
            </div>
        </div>

        <h5 class="mt-4">PRICES - PVP</h5>

        <div class="form-group row mb-4">
            <div v-if="taxes" class="col-sm-2">
                <label class="full">Tax</label>

                <v-select
                    v-model="selectedVatType"
                    :options="taxes"
                    placeholder="- Select tax -"
                    label="description"
                    @input="updateVatTypes">
                </v-select>
            </div>

            <div class="col-sm-9 d-flex align-items-center mt-3">
                <checkbox v-model="form.prices[0].priceIncludeTaxes">
                    Price with taxes
                </checkbox>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-sm-12">
                <div class="row mb-2 price-min-height-error" v-for="price,index in form.prices">
                    <div class="col-sm-2">
                        <label class="full">
                            Price <span class="brand">*</span>
                        </label>
                        
                        <div class="d-flex">
                            <input 
                            class="glued-right w-100" 
                            :class="{'border-color-6': $v.form.prices.$each[index].value.$invalid}" 
                            type="number"  
                            v-model="price.value">
                            
                            <div class="glued-left" :class="{ 'color-6': $v.form.prices.$each[index].value.$invalid }">€</div>
                        </div>
                        
                        <div class="color-6">
                            <div v-if="$v.form.prices.$each[index].value.$invalid" class="error messages">
                                <span>Price is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-8 pl-5">
                        <label class="full">
                            Label
                            <span class="brand">*</span>
                        </label>
                        
                        <input type="text" v-model="price.name" :class="{'border-color-6': $v.form.prices.$each[index].name.$invalid}" placeholder="PVP Name">
                        
                        <div class="color-6">
                            <div v-if="$v.form.prices.$each[index].name.$invalid" class="error messages">
                                <span>Label is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-2 d-flex align-items-center justify-content-end" v-if="form.prices.length > 1">
                        <div class="row mr-1">
                            <i class="ico ico-delete m-0 fs-large medium pointer" @click="removePrice(index)"></i>
                        </div>
                    </div>
                </div>

                <div class="add d-flex align-items-center pointer fs-small bold my-3">
                    <span @click="addPrice">
                        <i class="ico-add fs-smallest add-circle color-1"></i> New PVP
                    </span>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <label class="full">
                    Additional description
                    <textarea v-model="form.description" placeholder="e.g. Alert for high temperatures."></textarea>
                </label>
                <div class="italic fs-smaller dark mt-2">This message is public and is shown on the booking screen.</div>
            </div>
        </div>

		<div class="mt-3">
			<h5>Service status</h5>

			<div class="d-flex align-items-center w-100">
				<span class="fs-small bold mr-2">Service is active:</span>
				<toggle-button
					v-model="form.isActive"
					:labels="{checked: 'Yes', unchecked: 'No'}"
					:disabled="false"
				/>
			</div>
		</div>
    </form>
</template>

<script>
    import { mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, minLength, numeric, withParams } from 'vuelidate/lib/validators'

    export default {
        data() {
            return {
                billingProductIdTooltip: 'Family / Sub-Family of the external invoicing system',
                form: {
                    vatType: null,
                    isActive: true,
                    name: '',
                    priceType: null,
                    priceTotal: '',
                    prices:[
                        {
                            id:null,
                            name: null,
                            netPrice: null,
                            grossPrice: null,
                            value: null,
                            priceIncludeTaxes: true,
                            vatType: null
                        }
                    ],
					componentType: 0, // 0 = extra, 1 = transport
                },
                priceTax: 0.00,
                priceNet: 0.00,
                selectedPriceType: null,
                selectedVatType: null,
                showCapacity: true,
				componentTypeObject: null,
				componentTypesOptions: [
					{
						label: 'Extra',
						componentType: 0
					},
					{
						label: 'Transport',
						componentType: 1
					}
				]
            }
        },
        props: {
            isEdit: {
                type: Boolean,
                default: false
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                    repeatName: function (val) {
                        return !this.validateName(val);
                    }
                },
                prices: {
                    $each: {
                        value: {
                            required
                        },
                        name: {
                            required
                        }
                    }
                },
				isActive: false
            }
        },
        created() {
			this.componentTypeObject = this.componentTypesOptions.find(componentType => {
				return componentType.componentType == this.form.componentType;
			});

            if (this.getSelectedExtra) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedExtra));
                this.toggleCapacity();
            } else {
                this.form.isActive = true;
            }

            // Set vat type
            if (this.form.prices[0].vatType == null) {
                this.selectedVatType = this.taxes[0];
                this.form.vatType = this.taxes[0];
            } else {
                this.selectedVatType = this.taxes.filter(vatType => {
                    return vatType.id == this.form.prices[0].vatType;
                })[0]
            }
        },
        asyncComputed: {
            async priceTypes() {
                try {
                    let response = await axios.get('/api/settings/GetComponentExtraPriceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects
                        if (this.form.priceType) {
                            this.selectedPriceType = response.data.find(item => item.id === this.form.priceType);
                        } else {
                            this.selectedPriceType = response.data[0];
                            this.form.priceType = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        computed: {
            ...mapGetters([
                'getSelectedExtra',
                'getVatTypes',
                'getShowInvoiceOption',
                'getExtras',
            ]),
            taxes() {
                return this.getVatTypes
            },
            namesCount() {
                return this.getExtras.reduce((acc, obj) => {
                    if (obj.name) {
                        const key = obj.name.trim().toLowerCase();
                        acc[key] = (acc[key] || 0) + 1;
                    }

                    return acc;
                }, {});
            }
        },
        methods: {
            validateName(val) {
                const newName = val.trim().toLowerCase();

                if (this.isEdit) {
                    const oldName = this.getSelectedExtra && this.getSelectedExtra.name ? this.getSelectedExtra.name.trim().toLowerCase() : "";

                    if (oldName && newName === oldName) {
                        return false;
                    }
                }

                return (this.namesCount[newName] || 0) > 0;
            },
            updateTypes() {
                this.form.priceType = this.selectedPriceType.id || null;
                this.formatValue();
            },
            updateVatTypes() {
                this.form.prices[0].vatType = this.selectedVatType.id || null;
            },
            toggleCapacity() {
                if (this.form.capacityUnlimited) {
                    this.form.capacity = 0;
                    this.showCapacity = false;
                } else {
                    this.showCapacity = true;
                }
            },
            formatValue() {
                if (this.form.priceTotal || this.form.priceTotal === 0) {
                    this.form.priceTotal = this.formatPrice(this.form.priceTotal);
                }
            },
            addPrice() {
                let parentPrice = JSON.parse(JSON.stringify(this.form.prices[this.form.prices.length-1]));

                parentPrice.id = null;
                parentPrice.name = null;
                this.form.prices.push(parentPrice);
                this.$forceUpdate();
            },
            removePrice(index) {
                this.form.prices.splice(index, 1);
            },
			setComponentType(componentTypeId) {
				this.form.componentType = componentTypeId;
			}
        },
        watch: {
            $v: {
                handler: function (n, o) {
                    var toggleIsDisabled = (n.form.$invalid || n.form.$error) ? true : false;
                    this.$emit('toggleIsDisabled', toggleIsDisabled);

                    // Can we save? Have all validations been passed?
                    // Then we'll send the 'actual' form so we can
                    // set it as selectedItem
                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            },
			'form.componentType': {
				handler: function (n, o) {
					this.componentTypeObject = this.componentTypesOptions.find(componentType => {
						return componentType.componentType == n;
					});
				}
			}
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>
    .name-min-height-error {
        min-height: 100px;
    }

    .price-min-height-error {
        min-height: 75px;
    }
</style>



// WEBPACK FOOTER //
// ExtraForm.vue?6b1f51d2